import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import {onError} from 'apollo-link-error'
import { eventBus } from '@/main'
import Vue from 'vue'
import router from '../router'
import dataIdFromObject from './apolloDataId'

// Vue.prototype.$controllers = []
// todo controllers збирати контроллери для відміни запросів

const errorLink = onError(({graphQLErrors, networkError}) => {
  if (graphQLErrors && window.config?.node_env !== 'production' && window.config?.node_env !== 'development') {
    eventBus.$emit('showErrorSnackbar', graphQLErrors)
  }


  if (networkError && networkError.statusCode == 500) {
    router.push({name: 'page-error', params: { status_code: '500', descript: 'apolloClient'}}, () => {},() => {})
  }
})

/**
 * @param {String} lang Язык для запроса. В некоторых ситуациях, есть необходимость запросить переводы отличные от локализации сайта (например, при запросе переводов для писем)
 */
export default async function (path, overrideOrgId, save, lang) {
  let org =  router?.history?.pending?.params?.org
    || Number.parseInt(sessionStorage.getItem('OrganizationItId'))
    || 0

  // const availableOrganizations = Vue.prototype.$store.getters.getAvailableOrganizations
  // if (!availableOrganizations?.length || availableOrganizations.includes(org)) {
  //   org = 0
  // }
  org.isDefault
  if (Number.isNaN(org)) {
    org = 0
  }
  let controller = new AbortController()
  if ( save ) {
    Vue.prototype.$last_controller = controller
  }

  // Vue.prototype.$controllers.push(controller)  якшо нада бде список то можна шось такого типу
  const user = (await Vue.prototype.$auth.getUser())
  let token = user?.access_token

  if ( !token || user?.expired ) {

    let new_user = await Vue.prototype.$auth.renewToken(true)

    if ( !new_user ) {
      return router.push( {name: 'login'} )
    } else {
      token = new_user?.access_token
    }

  } // TODO: Herasymiuk  перевіряти чи є токен перед запросом - перевірити чи так ок відробляє

  const uri = window.config.GrapgQlUrl + (path ? path : '/purchasing')
  let options = {
    credentials: 'include',
    uri: uri,
    fetchOptions: { signal: controller.signal } ,
    headers: {
      'Authorization': `Bearer ${token ? token : ''}`,
      'Auth-Provider': 'SmartId',
      'OrganizationItId': overrideOrgId != undefined ? overrideOrgId : org,
      'culture': lang || sessionStorage.language,
      'accept-language': lang || sessionStorage.language,
      'href': window.location.href,
      // 'GodMode': '1'
    },
  }
  if (crypto?.randomUUID)  {
    options.headers.correlationId = crypto.randomUUID()
  }

  let my_local = localStorage.getObject(`${(user.profile.preferred_username || '').toLowerCase()}_settings`),
    GodMode = my_local && my_local.GodMode

  if ( GodMode ) {
    options.headers.GodMode = +GodMode
  }
  const cache = new InMemoryCache({
    dataIdFromObject,
  })

  const httpLink = new HttpLink(options)
  return new ApolloClient({
    cache: cache,
    link: errorLink.concat(httpLink),
    onError: error => Vue.prototype.$log_error(error.message)
  })
}
